// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HWmbo7 {
  display: flex;
  flex-direction: row;
  gap: var(--spacing-3);
  flex: 1;
  width: 100%;
  height: 100%;
}

.OwijPx {
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
  height: 100%;
  border-radius: var(--spacing-1);
  background-color: var(--surface-neutral-white);
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.12);
}

.MQoqf3 {
  display: flex;
  gap: var(--spacing-1);
  padding: var(--spacing-2-5) var(--spacing-3);
  align-items: center;
}

.Moj3gC {
  background-color: var(--color-primary, #d64000);
  width: var(--spacing-3);
  height: var(--spacing-3);
  border-radius: 12px;
  text-align: center;
  vertical-align: middle;
}

.HhavcQ {
  font-weight: 600;
  font-size: var(--font-size-md);
  color: var(--background-white, #ffffff);
}

.i88CfR {
  font-size: var(--font-size-lg);
  line-height: 100%;
  letter-spacing: 0px;
  vertical-align: middle;
  font-weight: 400;
  color: var(--surface-neutral-dark);
}

.vwbMp3 {
  min-height: auto;
  max-height: none;
  overflow: visible;
  padding: 0 var(--spacing-3) 24px;
}

.ELKSm5,
.nJf36l {
  border-bottom: 1px solid var(--Color-Gray-200, #e6e6e6);
}

.nJf36l {
  display: block;
  margin: 0;
  height: 1px;
  background-color: var(--Color-Gray-200, #e6e6e6);
}

.IBh_5g {
  width: 355px;
  display: flex;
  flex-direction: column;
  gap: var(--spacing-2-5);
  border-radius: 8px;
  background-color: var(--surface-neutral-white);
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.12);
}

.L8U8L9 {
  display: flex;
  padding: var(--spacing-2-5) var(--spacing-3) 0px var(--spacing-3);
  font-size: 16px;
  color: var(--surface-neutral-dark);
}

.xioJgM {
  display: flex;
  flex-direction: column;
  padding: 0px var(--spacing-3);
  margin-top: 0;
}

.XZdtxN {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.TjRHdG {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: var(--spacing-2) 0;
}

.SVVE5Z {
  display: flex;
  flex-direction: row;
  gap: var(--spacing-1);
  align-items: center;
  color: var(--surface-neutral-dark);
}

.kgwGbH {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  width: 24px;
  height: 24px;
  font-family: 'Source Sans 3', var(--font-family-base);
  font-weight: 600;
  font-size: 14px;
  line-height: 160%;
  text-align: center;
  color: #666666;
  background: transparent;
  border: 1px solid #666666;
}

.kgwGbH.fy6zYP {
  color: var(--background-white, #ffffff);
  background-color: var(--color-primary, #d64000);
  border: 1px solid var(--color-primary);
}

.jImqoj {
  text-indent: 10px;
  color: #666666;
  font-family: 'Source Sans 3', var(--font-family-base);
  font-size: 16px;
  font-weight: 400;
  line-height: 100%;
}

.jImqoj.pxEIj3 {
  color: var(--surface-neutral-dark);
  font-weight: 400;
}

.xA0vUO {
  border: none;
  background: transparent;
  font-size: var(--font-size-lg);
  cursor: pointer;
}

.AfBHZ2 {
  border: none;
  background: transparent;
  font-size: var(--font-size-sm);
  font-weight: 600;
  color: #d32f2f;
  cursor: pointer;
  padding: 2px 8px;
  border-radius: 4px;
  transition: background 0.2s;
}

.AfBHZ2:hover {
  background: rgba(211, 47, 47, 0.08);
}

.ThwNbL {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-1);
  margin-top: var(--spacing-3);
}

.tHEuw2 {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.vViOqL {
  width: 40%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: var(--font-size-md);
  color: var(--surface-neutral-dark);
}

._yOJvY {
  width: 58%;
  margin-left: 2%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: var(--font-size-md);
  font-weight: 600;
  color: var(--surface-neutral-dark);
}
`, "",{"version":3,"sources":["webpack://./../../packages/shared-ui/src/components/FormWizard/FormWizard.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,OAAO;EACP,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,8CAA8C;EAC9C,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EACE,+CAA+C;EAC/C,uBAAuB;EACvB,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,uCAAuC;AACzC;;AAEA;EACE,8BAA8B;EAC9B,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;;EAEE,uDAAuD;AACzD;;AAEA;EACE,cAAc;EACd,SAAS;EACT,WAAW;EACX,gDAAgD;AAClD;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;EAClB,8CAA8C;EAC9C,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,iEAAiE;EACjE,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;AACR;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,qDAAqD;EACrD,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,uCAAuC;EACvC,+CAA+C;EAC/C,sCAAsC;AACxC;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,qDAAqD;EACrD,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,8BAA8B;EAC9B,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE,UAAU;EACV,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,8BAA8B;EAC9B,gBAAgB;EAChB,kCAAkC;AACpC","sourcesContent":[".contentBody {\n  display: flex;\n  flex-direction: row;\n  gap: var(--spacing-3);\n  flex: 1;\n  width: 100%;\n  height: 100%;\n}\n\n.form {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  width: 100%;\n  height: 100%;\n  border-radius: var(--spacing-1);\n  background-color: var(--surface-neutral-white);\n  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.12);\n}\n\n.formTitle {\n  display: flex;\n  gap: var(--spacing-1);\n  padding: var(--spacing-2-5) var(--spacing-3);\n  align-items: center;\n}\n\n.formTitleStep {\n  background-color: var(--color-primary, #d64000);\n  width: var(--spacing-3);\n  height: var(--spacing-3);\n  border-radius: 12px;\n  text-align: center;\n  vertical-align: middle;\n}\n\n.formTitleStepLabel {\n  font-weight: 600;\n  font-size: var(--font-size-md);\n  color: var(--background-white, #ffffff);\n}\n\n.formTitleLabel {\n  font-size: var(--font-size-lg);\n  line-height: 100%;\n  letter-spacing: 0px;\n  vertical-align: middle;\n  font-weight: 400;\n  color: var(--surface-neutral-dark);\n}\n\n.formContent {\n  min-height: auto;\n  max-height: none;\n  overflow: visible;\n  padding: 0 var(--spacing-3) 24px;\n}\n\n.divider,\n.dividerItem {\n  border-bottom: 1px solid var(--Color-Gray-200, #e6e6e6);\n}\n\n.dividerItem {\n  display: block;\n  margin: 0;\n  height: 1px;\n  background-color: var(--Color-Gray-200, #e6e6e6);\n}\n\n.summary {\n  width: 355px;\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-2-5);\n  border-radius: 8px;\n  background-color: var(--surface-neutral-white);\n  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.12);\n}\n\n.summaryTitle {\n  display: flex;\n  padding: var(--spacing-2-5) var(--spacing-3) 0px var(--spacing-3);\n  font-size: 16px;\n  color: var(--surface-neutral-dark);\n}\n\n.summaryItems {\n  display: flex;\n  flex-direction: column;\n  padding: 0px var(--spacing-3);\n  margin-top: 0;\n}\n\n.summaryItem {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n\n.summaryItemHeader {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  padding: var(--spacing-2) 0;\n}\n\n.summaryItemTitle {\n  display: flex;\n  flex-direction: row;\n  gap: var(--spacing-1);\n  align-items: center;\n  color: var(--surface-neutral-dark);\n}\n\n.summaryItemNumber {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 12px;\n  width: 24px;\n  height: 24px;\n  font-family: 'Source Sans 3', var(--font-family-base);\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 160%;\n  text-align: center;\n  color: #666666;\n  background: transparent;\n  border: 1px solid #666666;\n}\n\n.summaryItemNumber.summaryItemNumberActive {\n  color: var(--background-white, #ffffff);\n  background-color: var(--color-primary, #d64000);\n  border: 1px solid var(--color-primary);\n}\n\n.summaryItemLabel {\n  text-indent: 10px;\n  color: #666666;\n  font-family: 'Source Sans 3', var(--font-family-base);\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 100%;\n}\n\n.summaryItemLabel.summaryItemLabelIsReached {\n  color: var(--surface-neutral-dark);\n  font-weight: 400;\n}\n\n.editStep {\n  border: none;\n  background: transparent;\n  font-size: var(--font-size-lg);\n  cursor: pointer;\n}\n\n.errorAction {\n  border: none;\n  background: transparent;\n  font-size: var(--font-size-sm);\n  font-weight: 600;\n  color: #d32f2f;\n  cursor: pointer;\n  padding: 2px 8px;\n  border-radius: 4px;\n  transition: background 0.2s;\n}\n\n.errorAction:hover {\n  background: rgba(211, 47, 47, 0.08);\n}\n\n.summarySection {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-1);\n  margin-top: var(--spacing-3);\n}\n\n.summaryRow {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.summarySectionTitle {\n  width: 40%;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  font-size: var(--font-size-md);\n  color: var(--surface-neutral-dark);\n}\n\n.summarySectionValue {\n  width: 58%;\n  margin-left: 2%;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  font-size: var(--font-size-md);\n  font-weight: 600;\n  color: var(--surface-neutral-dark);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"contentBody": `HWmbo7`,
	"form": `OwijPx`,
	"formTitle": `MQoqf3`,
	"formTitleStep": `Moj3gC`,
	"formTitleStepLabel": `HhavcQ`,
	"formTitleLabel": `i88CfR`,
	"formContent": `vwbMp3`,
	"divider": `ELKSm5`,
	"dividerItem": `nJf36l`,
	"summary": `IBh_5g`,
	"summaryTitle": `L8U8L9`,
	"summaryItems": `xioJgM`,
	"summaryItem": `XZdtxN`,
	"summaryItemHeader": `TjRHdG`,
	"summaryItemTitle": `SVVE5Z`,
	"summaryItemNumber": `kgwGbH`,
	"summaryItemNumberActive": `fy6zYP`,
	"summaryItemLabel": `jImqoj`,
	"summaryItemLabelIsReached": `pxEIj3`,
	"editStep": `xA0vUO`,
	"errorAction": `AfBHZ2`,
	"summarySection": `ThwNbL`,
	"summaryRow": `tHEuw2`,
	"summarySectionTitle": `vViOqL`,
	"summarySectionValue": `_yOJvY`
};
module.exports = ___CSS_LOADER_EXPORT___;
